import { userInfoAtom } from 'app/atoms';
import { PCImage } from 'app/design/primitives/image';

import { getImageVariantForSize, getImageVariantUrl } from 'app/lib/image-variants';
import type { ChatUser } from 'app/types/chat';
import { useAtomValue } from 'jotai';
import React from 'react';
import { View } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

interface GroupAvatarStackProps {
  members: ChatUser[];
  size?: number;
  myUserId?: string; // optional prop to specify the current user's ID, if needed for filtering
}

export const GroupAvatarStack = function GroupAvatarStack({ members, size = 40, myUserId }: GroupAvatarStackProps) {
  const userFromAtom = useAtomValue(userInfoAtom);
  const user = myUserId ? { id: myUserId } : userFromAtom;
  const otherMembers = members.filter((m) => m.user_id !== user?.id).slice(0, 2);
  const hasTwoAvatars = otherMembers.length === 2;
  const avatarSize = hasTwoAvatars ? Math.round(size * 0.7) : size;
  const inset = size - avatarSize;

  return (
    <View style={{ width: size, height: size, position: 'relative' }}>
      {otherMembers.map((member, index) => {
        const left = hasTwoAvatars ? (index === 0 ? 0 : inset) : 0;
        const top = hasTwoAvatars ? (index === 0 ? inset : 0) : 0;
        const zIndex = index === 0 ? 2 : 1;

        return (
          <View
            key={member.user_id}
            style={{
              position: 'absolute',
              left,
              top,
              zIndex,
              width: avatarSize,
              height: avatarSize,
              borderRadius: avatarSize / 2,
              borderWidth: 1.5,
              borderColor: theme.colors['surface.default'],
              overflow: 'hidden',
              backgroundColor: theme.colors['surface.disabled'],
            }}
          >
            {member.profile_url ? (
              <PCImage
                aspectRatio={1}
                cachePolicy="memory-disk"
                height={avatarSize}
                recyclingKey={`${member.user_id}-group-stack`}
                source={{
                  uri: getImageVariantUrl(member.profile_url, getImageVariantForSize(avatarSize * 2, avatarSize * 2)),
                }}
                style={{ borderRadius: avatarSize / 2 }}
              />
            ) : null}
          </View>
        );
      })}
    </View>
  );
};
